/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_ConfirmedInputs */

const en_vendor_return_status_confirmed = /** @type {(inputs: Vendor_Return_Status_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Vendor_Return_Status_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_confirmed = /** @type {((inputs?: Vendor_Return_Status_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_confirmed(inputs)
});